module.exports = __webpack_public_path__ + "static/media/scenario4_preview.daae6eed.jpg";